import React, { FC, ReactNode, useCallback, useContext } from 'react'
import { ScreenContext } from 'react-components'

import { BackButton, ContentContainer, Container, LogoContainer, LogoImage, SearchbarWrapper } from './styles'
import HeroSearchbar from '../../common/hero-section/hero-searchbar'
import { useTranslation } from '../../../hooks/locale'
import { NavigationTransport } from '../../../transports/common/navigation-section-transport'
import UserDetailsModel from '../../../models/user/user-details-model'
import NavigationBar from './navigation-bar'
import SearchRegionNodeTransport from '../../../transports/search-region-node-transport'
import { SearchbarMode } from './types'

import { BackIcon } from '../../common/icons'

interface Props {
    searchRegionNode: SearchRegionNodeTransport | null
    siteRelativeURL: string
    userDetails: UserDetailsModel | null
    navigation: NavigationTransport
    searchbarMode?: SearchbarMode
    children?: ReactNode
}

const HeaderSection: FC<Props> = ({
    searchRegionNode,
    siteRelativeURL,
    userDetails,
    navigation,
    children,
    searchbarMode = SearchbarMode.MAIN,
}) => {
    const { logo } = navigation
    const { isMobile } = useContext(ScreenContext)
    const { t } = useTranslation()

    const goBack = useCallback(() => {
        window?.history?.back()
    }, [])

    return (
        <Container id="header">
            <ContentContainer>
                {isMobile ? (
                    <BackButton onClick={goBack}>
                        <BackIcon alt={t('backIconText')} />
                    </BackButton>
                ) : (
                    !!logo?.image && (
                        <LogoContainer href={logo.url}>
                            <LogoImage src={logo.image.url} alt={logo.image.alt} />
                        </LogoContainer>
                    )
                )}
                {!!searchRegionNode && (
                    <SearchbarWrapper searchbarMode={searchbarMode}>
                        <HeroSearchbar
                            initialLocation={searchRegionNode?.search}
                            logo={logo}
                            isSticky={false}
                            petsAllowed={false}
                            maxWidth="70rem"
                            searchbarMode={searchbarMode}
                            searchRegionNode={searchRegionNode}
                        />
                    </SearchbarWrapper>
                )}
                <NavigationBar userDetails={userDetails} navigation={navigation} siteRelativeURL={siteRelativeURL} />
            </ContentContainer>
            {children}
        </Container>
    )
}

export default HeaderSection
